if (!customElements.get('estimated-delivery')) {
  customElements.define(
    'estimated-delivery',
    class EstimatedDelivery extends HTMLElement {
      connectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }

        const jsonEl = this.querySelector('[data-estimated-delivery-windows]');
        if (!jsonEl) return;

        try {
          this.windows = JSON.parse(jsonEl.textContent);
        } catch (error) {
          return;
        }

        if (!Array.isArray(this.windows) || !this.windows.length) return;

        this.countdownEl = this.querySelector('[data-countdown]');
        this.dateEl = this.querySelector('[data-delivery-date]');
        this.dateEndEl = this.querySelector('[data-delivery-date-end]');
        this.dateRangeEl = this.querySelector('[data-date-range]');
        this.dispatchEl = this.querySelector('[data-dispatch-date]');
        this.rangeSeparatorEl = this.querySelector('[data-range-separator]');
        this.startedAt = Date.now();
        this.activeIndex = -1;

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      tick() {
        const elapsed = Math.floor((Date.now() - this.startedAt) / 1000);
        let index = this.windows.length - 1;

        for (let i = 0; i < this.windows.length; i++) {
          if (this.windows[i].remaining > elapsed) {
            index = i;
            break;
          }
        }

        const windowData = this.windows[index];
        const remaining = Math.max(0, windowData.remaining - elapsed);

        if (index !== this.activeIndex) {
          this.activeIndex = index;
          this.applyWindow(windowData);
        }

        if (this.countdownEl) {
          this.countdownEl.textContent = this.formatCountdown(remaining);
        }
      }

      applyWindow(windowData) {
        if (this.dateEl && windowData.date) this.dateEl.textContent = windowData.date;
        if (this.dateEndEl) this.dateEndEl.textContent = windowData.date_end || '';
        if (this.dateRangeEl && windowData.date_range) this.dateRangeEl.textContent = windowData.date_range;
        if (this.dispatchEl && windowData.dispatch_date) this.dispatchEl.textContent = windowData.dispatch_date;

        const hasRange = Boolean(windowData.date_end && windowData.date_end !== windowData.date);
        if (this.rangeSeparatorEl) this.rangeSeparatorEl.hidden = !hasRange;
        if (this.dateEndEl) this.dateEndEl.hidden = !hasRange;
      }

      formatCountdown(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${hours}h ${this.pad(minutes)}min ${this.pad(seconds)}s`;
      }

      pad(value) {
        return value < 10 ? `0${value}` : String(value);
      }
    }
  );
}

(function initEstimatedDeliveryToggles() {
  if (window.__estimatedDeliveryToggleBound) return;
  window.__estimatedDeliveryToggleBound = true;

  const BLOCK_SELECTOR = '.estimated-delivery[data-click-trigger]';

  function blocks() {
    return Array.from(document.querySelectorAll(BLOCK_SELECTOR));
  }

  function showBlock(el) {
    el.classList.remove('estimated-delivery--hidden');
    el.removeAttribute('hidden');
  }

  function hideBlock(el) {
    el.classList.add('estimated-delivery--hidden');
    el.setAttribute('hidden', '');
  }

  function activate(triggerId, group) {
    blocks().forEach((el) => {
      if ((el.dataset.toggleGroup || 'default') !== group) return;
      if (el.dataset.clickTrigger === triggerId) {
        showBlock(el);
      } else {
        hideBlock(el);
      }
    });
  }

  function triggerIdFromEvent(event) {
    const knownIds = new Set(blocks().map((el) => el.dataset.clickTrigger).filter(Boolean));
    if (!knownIds.size) return null;

    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const nodes = path.length ? path : [event.target];

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (!node || node.nodeType !== 1) continue;
      if (node.id && knownIds.has(node.id)) return node.id;
      if (node.htmlFor && knownIds.has(node.htmlFor)) return node.htmlFor;
    }

    const target = event.target;
    if (!target || typeof target.closest !== 'function') return null;

    for (const id of knownIds) {
      const escaped = window.CSS && CSS.escape ? CSS.escape(id) : id;
      if (target.closest('#' + escaped) || target.closest('[for="' + id + '"]')) {
        return id;
      }
    }

    return null;
  }

  function onToggleEvent(event) {
    const triggerId = triggerIdFromEvent(event);
    if (!triggerId) return;

    const block = blocks().find((el) => el.dataset.clickTrigger === triggerId);
    if (!block) return;

    activate(triggerId, block.dataset.toggleGroup || 'default');
  }

  function syncFromCheckedTriggers() {
    const seenGroups = new Set();

    blocks().forEach((block) => {
      const triggerId = block.dataset.clickTrigger;
      const group = block.dataset.toggleGroup || 'default';
      if (!triggerId || seenGroups.has(group)) return;

      const trigger = document.getElementById(triggerId);
      if (!trigger) return;

      const selected =
        trigger.checked === true ||
        trigger.getAttribute('aria-pressed') === 'true' ||
        trigger.getAttribute('aria-selected') === 'true';

      if (selected) {
        seenGroups.add(group);
        activate(triggerId, group);
      }
    });
  }

  function scheduleSync() {
    syncFromCheckedTriggers();
    setTimeout(syncFromCheckedTriggers, 800);
  }

  document.addEventListener('click', onToggleEvent);
  document.addEventListener('change', onToggleEvent);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();

 
